import React, { useState, useRef } from 'react';
import MultiSelectOptionsList from './MultiSelectOptionList';
import useClickOutside from '../../../hooks/useClickOutside';
import { CustomSelectsOption, ISelectedItem } from './MultiSelectCheck';
import Button, { ButtonVariant } from '../../Buttons/Button';
import { IconType } from 'react-icons';

export interface IIconMultiSelect {
    options: CustomSelectsOption[];
    onSelect: (selectedItems: ISelectedItem) => void;
    selectedItems: ISelectedItem[];
    label: string;
    icon: IconType;
    className?: string;
    variant: ButtonVariant;
}

function IconMultiSelect({
    options,
    onSelect,
    selectedItems,
    label,
    icon,
    variant
}: IIconMultiSelect) {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useClickOutside(ref, () => setIsOpen(false));

    const handleClick = (option: CustomSelectsOption) => {
        onSelect({
            label,
            value: option.value,
            ...(option.id !== undefined && { id: Number(option.id) }),
        });
    };

    const toggleOpen = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <div ref={ref} className='relative'>
            <Button
                onClick={toggleOpen}
                icon={icon}
                aria-label={label}
                label=''
                variant={variant}
                iconSize={16}
                className="!px-3 !h-[32px]"
            />
            {isOpen && (
                <MultiSelectOptionsList
                    options={options}
                    selectedItems={selectedItems}
                    onSelect={handleClick}
                    className='absolute right-0 mt-1 !w-[12.5rem] rounded-sm shadow-custom-dual bg-primary-100 z-[8880] max-h-[260px] overflow-y-auto'
                />
            )}
        </div>
    );
}

export default IconMultiSelect;